module.exports = __webpack_public_path__ + "static/media/jamie-sparker-films.8b50e685.jpeg";